import SeoHead from "@/Component/Seo/SeoHead";
import ThingsToDo from "@/Component/ThingsToDo";
import { serverFetchThingsToDo } from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { normalizeThingsToDoResponse } from "@/utils/thingsToDoHelpers";
import { renderNotFoundPage } from "@/utils/detailSlug";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function PlacePage({ seo, seoCountry, slug, pageData }) {
  const fallbackTitle = pageData?.detail?.name || "Things To Do";

  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle={`${fallbackTitle} | Next Holidays`}
      />
      <ThingsToDo slug={slug} pageData={pageData} />
    </>
  );
}

export async function getServerSideProps(context) {
  const slugParam = context.params?.slug;
  const slug = Array.isArray(slugParam) ? slugParam[0] : slugParam;

  if (!slug) {
    return renderNotFoundPage(context);
  }

  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  try {
    const thingsToDoResponse = await serverFetchThingsToDo(slug, country);

    if (String(thingsToDoResponse?.status || "").toLowerCase() === "success") {
      return {
        props: {
          seo: seoResult.seo,
          seoCountry: seoResult.seoCountry,
          slug,
          pageData: normalizeThingsToDoResponse(thingsToDoResponse),
        },
      };
    }
  } catch (error) {
    console.error("Place page SSR error:", error);
  }

  return renderNotFoundPage(context);
}
